export function getNaturalizedField(naturalized, fieldName, defaultValue = undefined, index = 0) {
    if (!naturalized) {
        return defaultValue;
    }
    const value = naturalized[fieldName];
    if (value === undefined || value === null) {
        return defaultValue;
    }
    if (Array.isArray(value)) {
        const indexedValue = value[index];
        return indexedValue === undefined || indexedValue === null
            ? defaultValue
            : indexedValue;
    }
    if (index !== 0) {
        return defaultValue;
    }
    return value;
}
export function getNaturalizedString(naturalized, fieldName, defaultValue = undefined, index = 0) {
    const value = getNaturalizedField(naturalized, fieldName, defaultValue, index);
    if (value === null || value === undefined) {
        return defaultValue;
    }
    return String(value);
}
export function getNaturalizedNumber(naturalized, fieldName, defaultValue = undefined, index = 0) {
    const value = getNaturalizedField(naturalized, fieldName, defaultValue, index);
    if (value === null || value === undefined) {
        return defaultValue;
    }
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : defaultValue;
}
